import classNames from 'classnames'
import { memo, useCallback } from 'react'
import { FaUserGroup } from 'react-icons/fa6'
import { useShallow } from 'zustand/react/shallow'
import { useGetMyProfileMini } from '../../../../../../hooks/queries/profile/use-get-my-profile-mini'
import { useGlobalStore } from '../../../../../../store/global-store'
import { useGetDataSeats } from '../use-get-data-seats'

export const SelectAll = memo(() => {
  const { streamerId, typeLive, userIdToSendGift, isSelectedAll } =
    useGlobalStore(
      useShallow((state) => ({
        // live: state.live,
        streamerId: state.liveUserId,
        typeLive: state.typeLive,
        userIdToSendGift: state.userIdToSendGift,
        isSelectedAll: state.isSelectedAll,
      })),
    )

  const { user: userGlobal } = useGetMyProfileMini()

  const { dataSeats } = useGetDataSeats()

  const handleSelectAll = useCallback(() => {
    // O filtro que me EXCLUÍA virou só validação de id. Ele existia porque o
    // backend derrubava o LOTE INTEIRO com cannot_gift_yourself se eu estivesse
    // dentro; sem o guard, "todos" quer dizer todos mesmo, eu inclusive.
    const myId = Number(userGlobal?.id)
    const idValido = (id: unknown) => id != null && Number.isFinite(Number(id))

    if (!typeLive?.includes('multi')) {
      return useGlobalStore.setState(() => {
        const data = new Set<number>()

        if (idValido(streamerId)) data.add(Number(streamerId))
        if (idValido(userIdToSendGift)) data.add(Number(userIdToSendGift))

        return {
          usersToGift: data,
          isSelectedAll: true,
        }
      })
    }

    const newSet = new Set<number>()
    // o host (streamerId) entra na leva de "todos"
    if (idValido(streamerId)) newSet.add(Number(streamerId))
    dataSeats.forEach((user) => {
      if (idValido(user?.userId)) newSet.add(Number(user?.userId))
    })
    if (idValido(myId)) newSet.add(myId)

    useGlobalStore.setState({ usersToGift: newSet, isSelectedAll: true })
  }, [streamerId, dataSeats, userIdToSendGift, userGlobal?.id, typeLive])

  const handleClearUsersToGift = useCallback(() => {
    useGlobalStore.setState({ isSelectedAll: false })
    useGlobalStore.setState({ usersToGift: new Set() })
  }, [])

  return (
    typeLive?.includes('multi') && (
      <div
        className={classNames(
          'rounded-full flex w-10 h-10 items-center justify-center text-white',
          {
            'border-2 border-purple-600': isSelectedAll,
          },
        )}
        onClick={isSelectedAll ? handleClearUsersToGift : handleSelectAll}
      >
        <FaUserGroup />
      </div>
    )
  )
})
